import * as RequestDueDiligenceTypes from 'src/actions/project/due-diligence/Types';
import { RequestDueDiligenceAction } from 'src/actions/project/due-diligence/RequestDueDiligence.actions';

export interface RequestDueDiligenceState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: RequestDueDiligenceState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function RequestDueDiligenceReducer(state: RequestDueDiligenceState = initialState,
                                           action: RequestDueDiligenceAction): RequestDueDiligenceState {
  switch (action.type) {
    case RequestDueDiligenceTypes.REQUEST_DUE_DILIGENCE_ATTEMPT:
      return {...state, loading: true, error: false};
    case RequestDueDiligenceTypes.REQUEST_DUE_DILIGENCE_SUCCESS:
      return {...state, loading: false, error: false};
    case RequestDueDiligenceTypes.REQUEST_DUE_DILIGENCE_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/project/RequestDueDiligenceReducer.tsx